export class CompromisosXFecha{
    public id!:string;
    public titulo!:string;
    public fecha!:Date;
    public estiloHoy:string = '';
    public estiloFestivo:string = '';
    public esHoy:string='NO';
    public listaCompromisos:Array<any> = new Array() ;
}